<app-simple-modal-header [pageTitle]="pageTitle" (dismissed)="dismiss()">
	<form [formGroup]="filterForm" *ngIf="filterForm">
		<ion-list>
			<ion-item>
				<ion-label position="stacked">Category</ion-label>
				<ion-select
					class="text-wrap"
					placeholder="Select"
					[interfaceOptions]="{ header: 'Category' }"
					(ionChange)="onChangeCategory($event.detail.value)"
					[formControl]="filterForm.controls.categoryId"
				>
					<ion-select-option
						*ngFor="let category of categoryOptions"
						[value]="category.id"
					>
						{{ category.name }}
					</ion-select-option>
				</ion-select>
			</ion-item>
			<ion-item>
				<ion-label position="stacked">Equipment</ion-label>
				<ion-select
					class="text-wrap"
					placeholder="Select"
					[interfaceOptions]="{ header: 'Equipment' }"
					(ionChange)="onChangeEquipment($event.detail.value)"
					[formControl]="filterForm.controls.equipment"
					[compareWith]="formHelper.compareWith"
				>
					<ion-select-option
						*ngFor="let equipment of equipmentOptions"
						[value]="equipment"
					>
						{{ equipment.name }}
					</ion-select-option>
				</ion-select>
			</ion-item>
			<ion-item *ngIf="filterForm.controls.equipment.value">
				<ion-label position="stacked">
					{{ primaryAttributeName }}
					<ion-text color="danger">
						*
					</ion-text>
				</ion-label>
				<ion-input [formControl]="filterForm.controls.primaryAttribute">
				</ion-input>
			</ion-item>
		</ion-list>
	</form>

	<ion-buttons slot="end" *ngIf="canToggle">
		<ion-button (click)="toggleMode()">
			<ion-icon name="business-outline"></ion-icon>
		</ion-button>
	</ion-buttons>
</app-simple-modal-header>

<ion-content>
	<form [formGroup]="dynamicAttributesForm" *ngIf="dynamicAttributesForm">
		<ion-list lines="full">
			<ion-item *ngFor="let attribute of dynamicAttributes; index as index">
				<ion-label position="stacked" class="bold">
					{{ attribute.attribute }}
					<ion-text *ngIf="attribute.isRequired" color="danger">
						*
					</ion-text>
				</ion-label>
				<ion-input *ngIf="attribute.dataType == 'int'"
						   (keypress)="inventoryFormHelper.preventNonInteger($event)"
						   type="number"
						   [formControl]="dynamicAttributesForm.controls[index]"></ion-input>
				<ion-input *ngIf="attribute.dataType == 'char'"
						   (keypress)="
						inventoryFormHelper.preventNonAlphaCharacter($event)
					"
						   [formControl]="dynamicAttributesForm.controls[index]"></ion-input>
				<ion-input *ngIf="attribute.dataType == 'varchar'"
						   [formControl]="dynamicAttributesForm.controls[index]"></ion-input>
				<ion-input *ngIf="attribute.dataType == 'money'"
						   type="tel"
						   (keypress)="inventoryFormHelper.preventNonCurrency($event)"
						   (ionBlur)="inventoryFormHelper.formatMoneyInput($event)"
						   [formControl]="dynamicAttributesForm.controls[index]"></ion-input>
				<ion-input *ngIf="attribute.dataType == 'datetime'"
						   [formControl]="dynamicAttributesForm.controls[index]"
						   id="addWarehouseInventoryOpenCalendar{{index}}"
						   readonly="true"></ion-input>
				<ion-popover trigger="addWarehouseInventoryOpenCalendar{{index}}" show-backdrop="true">
					<ng-template>
						<ion-datetime [showDefaultButtons]="true"
										[value]="inventoryFormHelper.toDateTimeString(dynamicAttributesForm.controls[index].value)"
										(ionChange)="dynamicAttributesForm.controls[index].setValue(inventoryFormHelper.toInventoryDateString($event.target.value))"></ion-datetime>
					</ng-template>
				</ion-popover>
				<ion-select *ngIf="attribute.dataType == 'boolean'"
							[formControl]="dynamicAttributesForm.controls[index]">
					<ion-select-option [value]="''"></ion-select-option>
					<ion-select-option [value]="'No'">
						No
					</ion-select-option>
					<ion-select-option [value]="'Yes'">
						Yes
					</ion-select-option>
				</ion-select>
				<ion-select *ngIf="attribute.dataType == 'customerservice'"
							[compareWith]="inventoryFormHelper.serviceCompareWith"
							[formControl]="dynamicAttributesForm.controls[index]">
					<ion-select-option [value]="''"></ion-select-option>
					<ion-select-option *ngFor="let service of serviceOptions"
									   [value]="service.id">
						{{ service.desc }}
					</ion-select-option>
				</ion-select>
			</ion-item>
		</ion-list>
	</form>
</ion-content>

<ion-footer>
	<ion-grid>
		<ion-row>
			<ion-col size="6">
				<ion-button
					*ngIf="!disableWarehouseValidation && !hasValidated"
					expand="full"
					class="modal__submit"
					(click)="validateInventory()"
				>
					Validate
				</ion-button>
			</ion-col>
			<ion-col size="6">
				<ion-button
					*ngIf="hasValidated"
					expand="full"
					class="modal__submit"
					(click)="onClickAddInventory()"
				>
					Add Inventory
				</ion-button>
			</ion-col>
		</ion-row>
	</ion-grid>
</ion-footer>
